// @ts-nocheck
import * as yup from 'yup';

/** Factory so messages can be localized via t() */
export function buildSchemas(t) {
    const req = t('required');
    return {
        login: yup.object({
            email: yup.string().email(t('invalidEmail')).required(req),
            password: yup.string().min(6, t('minPassword')).required(req),
        }),
        project: yup.object({
            name: yup.string().required(req).max(200, t('maxLength')),
            code: yup.string().nullable(),
            location: yup.string().nullable(),
            address: yup.string().nullable(),
            description: yup.string().nullable(),
            status: yup.string().required(req),
        }),
        unit: yup.object({
            project_id: yup.mixed().required(t('selectProject')),
            unit_number: yup.string().required(req),
            unit_type: yup.string().required(req),
            sale_price: yup
                .number()
                .typeError(t('mustBeNumber'))
                .min(0, t('mustBePositive'))
                .required(req),
            floor: yup.string().nullable(),
            block: yup.string().nullable(),
            size_sqft: yup.number().typeError(t('mustBeNumber')).nullable(),
            bedrooms: yup.number().typeError(t('mustBeNumber')).nullable(),
            bathrooms: yup.number().typeError(t('mustBeNumber')).nullable(),
            status: yup.string().required(req),
        }),
        bulkUnits: yup.object({
            project_id: yup.mixed().required(t('selectProject')),
            building: yup.string().required(req),
            blocks: yup.string().nullable(),
            units_per_floor: yup
                .number()
                .typeError(t('mustBeNumber'))
                .min(1, t('mustBePositive'))
                .required(req),
            numbering: yup.string().required(req),
            unit_type: yup.string().required(req),
            sale_price: yup.number().typeError(t('mustBeNumber')).nullable(),
        }),
        lead: yup.object({
            name: yup.string().required(req),
            phone: yup.string().required(req),
            email: yup.string().email(t('invalidEmail')).nullable(),
            source: yup.string().nullable(),
            notes: yup.string().nullable(),
        }),
        booking: yup.object({
            project_id: yup.mixed().required(t('selectProject')),
            unit_id: yup.mixed().required(t('selectUnit')),
            customer_id: yup.mixed().required(t('selectCustomer')),
            booking_date: yup.string().required(req),
            sale_price: yup.number().typeError(t('mustBeNumber')).min(0).required(req),
            booking_money: yup.number().typeError(t('mustBeNumber')).nullable(),
            discount: yup.number().typeError(t('mustBeNumber')).nullable(),
        }),
        expense: yup.object({
            title: yup.string().required(req),
            amount: yup.number().typeError(t('mustBeNumber')).positive(t('mustBePositive')).required(req),
            expense_date: yup.string().required(req),
            category: yup.string().nullable(),
            project_id: yup.mixed().nullable(),
        }),
        user: yup.object({
            name: yup.string().required(req),
            email: yup.string().email(t('invalidEmail')).required(req),
            phone: yup.string().nullable(),
            password: yup.string().min(6, t('minPassword')).required(req),
            role: yup.string().required(req),
        }),
        payment: yup.object({
            amount: yup.number().typeError(t('mustBeNumber')).positive(t('mustBePositive')).required(req),
            payment_date: yup.string().required(req),
            payment_method: yup.string().required(req),
        }),
    };
}
